const getProfileFromSessionStorage = () => {
  if (!window) return null

  return window.sessionStorage.getItem("userData")
}

export default getProfileFromSessionStorage
